import React, { useState } from "react";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import type { All8PageContent } from "@bcc/core-renderers";
import type { ObjectFieldConfig, Path } from "../../Pages/pageComponentLibrary";
import PageEditorFieldControl from "./PageEditorFieldControl";

export type PageEditorObjectFieldProps = {
	editable: boolean;
	field: ObjectFieldConfig;
	componentIndex: number;
	parentPath: Path;
	previewComponents: All8PageContent;
	updateComponentValue: (index: number, path: Path, value: any) => void;
	allowImageVariables?: boolean;
};

const PageEditorObjectField: React.FC<PageEditorObjectFieldProps> = ({
	editable,
	field,
	componentIndex,
	parentPath: fullPath,
	previewComponents,
	updateComponentValue,
	allowImageVariables
}) => {
	const [open, setOpen] = useState(false);
	return (
		<div className="space-y-2 rounded-xl border border-slate-200 bg-slate-50 overflow-hidden">
			<div
				role="button"
				tabIndex={0}
				onClick={() => setOpen((o) => !o)}
				onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setOpen((o) => !o)}
				className="flex items-center gap-2 px-3 py-2 text-left transition hover:bg-slate-100"
				aria-expanded={open}
			>
				{open ? (
					<FiChevronDown className="h-4 w-4 shrink-0 text-slate-500" />
				) : (
					<FiChevronRight className="h-4 w-4 shrink-0 text-slate-500" />
				)}
				<span className="text-xs font-semibold uppercase tracking-wide text-slate-600">{field.label}</span>
			</div>
			{open && (
				<div className="space-y-3 border-t border-slate-200 bg-white p-3">
					{field.fields.map((child, idx) => (
						<div key={`${field.label}-${idx}`}>
							<PageEditorFieldControl
								editable={editable}
								field={child}
								componentIndex={componentIndex}
								parentPath={fullPath}
								previewComponents={previewComponents}
								updateComponentValue={updateComponentValue}
								allowImageVariables={allowImageVariables}
							/>
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default PageEditorObjectField;
